// 都道府県の北→南順リスト。
// 「すべての地点」リストをこの順で並べるためのソートキーとして使用する。
// データ側には都道府県コードを持たないため、フロント側で名前ベースで順序を決める。
//
// 並びは JIS X 0401 の都道府県コード順（=おおむね北→南）に準拠。
//   - 関東は茨城→...→神奈川
//   - 中部は新潟→...→愛知
//   - 近畿は三重→...→和歌山（三重を中部に含めず近畿に含めるかは流派あり、ここは JIS 順）
//
// 内陸 8 県（栃木・群馬・埼玉・山梨・長野・岐阜・滋賀・奈良）は本データには登場しないが、
// 将来追加に備えて配列には含めておく。

export const PREF_ORDER: readonly string[] = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
];

/**
 * 都道府県名をソートキー（数値）に変換する。
 * リストに無い県名は末尾扱い（例: 「その他」など）。
 */
export function prefectureOrder(name: string | null | undefined): number {
  if (!name) return Number.MAX_SAFE_INTEGER;
  const i = PREF_ORDER.indexOf(name);
  return i === -1 ? Number.MAX_SAFE_INTEGER : i;
}
